import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./routes/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/main.css";

// Adding reacti18next for internationalization
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { Loader } from "./components/Loader";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["fr", "en"],
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    fallbackLng: "fr",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
  });

const loadingMarkup = <div style={{ height:"100vh", width: "100vw", display: "block", position: "absolute"}}><Loader /></div>;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Suspense fallback={loadingMarkup}>
    <App tab="home" />
  </Suspense>
);
